const DriverInputs = [
        {
      id: "Name",
      label: "Full Name",
      type: "text",
      placeholder: "eg. Suresh Mehta",
    },
    {
      id: "Skills",
      label: "Skills",
      type: "text",
      placeholder: "Give brief about skills you have",
    },

    {
      id: "email",
      label: "Email",
      type: "mail",
      placeholder: "suresh@gmail.com",
    },
    {
      id: "phone",
      label: "Phone",
      type: "text",
      placeholder: "+91 234 567 89",
    },

  ];
  export default DriverInputs;  